<template>
  <div id="app">
    <transition :name="transitionName">
      <router-view v-wechat-title="$route.meta.title" class="router-view"/>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'App',
    components: {
    },
    data () {
      return {
        mobile: '',
        // transitionName: ''
        transitionName: 'slide-left'
      }
    },
    watch: {
      // '$route' (to, from) {
      //   const toDepth = to.path.split('/').length
      //   const fromDepth = from.path.split('/').length
      //   this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
      // }
    },
    mounted() {
      // if (!this._isMobile()) {
      //   this.$router.push('/pc')
      // }
    },
    methods: {
      _isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag
      }
    }
  }
</script>
<style src="../node_modules/mint-ui/lib/style.css"></style>
<style lang="scss" src="./assets/stylesheets/scss/app.scss"></style>
<style lang="scss">
  //渐变动效
  .slide-left-enter-active,
  .slide-left-leave-active {
    transition: all 0.1s ease-in;
    opacity: 1;
  }
  .slide-left-enter,
  .slide-left-leave-active {
    opacity: 0;
  }
  //左滑动效
   /*.slide-left-enter-active {*/
     /*animation: slideLeft .3s;*/
   /*}*/
  // }
  @keyframes slideLeft {
    from {
      transform: translate3d(100%, 0, 0);
      visibility: visible;
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue